module.exports = "/_next/static/images/Cristina_Cocieru-0dd886d9c28717b262de9dad037ec959.webp";